import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClientXsrfModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import 'hammerjs';
import { AppRoutingModule } from './app-routing.module';


import { DatePipe } from '@angular/common';

import { PipesModule } from './_pipes/pipes.module';


import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { IntroTextComponent } from './intro-text/intro-text.component';
import { IntroTextModernComponent } from './intro-text-modern/intro-text-modern.component';
import { HeroSearchComponent } from './intro-text-modern/hero-search/hero-search.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { AssayProposalComponent } from './assay-proposal/assay-proposal.component';
import { AboutComponent } from './about/about.component';
import { CompoundSearchComponent } from './compound-search/compound-search.component';
import { DownloadGuideComponent } from './download-guide/download-guide.component';
import {SearchBoxComponent, SearchResultsTableComponent, StructureSearchOptionsComponent,
  StructureSearchComponent, TextSearchComponent, AssayIndicationComponent, KetcherComponent
} from './compound-search/index';

import { CompoundCardComponent } from './compound-card/compound-card.component';

import { MatTableModule } from '@angular/material/table';  // Import MatTableModule
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import {
    QuickSearchComponent,
    UserLoginComponent,
    UserRegButtonComponent,
    ForgotPassButtonComponent,
    LoaderComponent } from './_components/index';


import { LoaderInterceptorService } from './_interceptors/loader-interceptor.service';

// --- Services ---
import {

  LoaderStateService,
  LoginStateService,
  SearchResultService,
  WDQService,
  StructureService,
  TanimotoScaleService,
  StructureSvgService,
  ColorPaletteService,
  BackendSearchService,
  FavoritesService,
  CompoundListsService
} from './_services/index';

// Custom Modules
import { RecaptchaModule } from 'ng-recaptcha';
import { MaterialModule } from './material.module';
import { Struct2dModule } from './struct2d/struct2d.module';

import { ForgotPasswordComponent, LoginFailComponent, UserRegistrationComponent } from './_dialogs/index';
import { UserPortalModule } from './user-portal/user-portal.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    IntroTextComponent,
    IntroTextModernComponent,
    HeroSearchComponent,
    WorkflowComponent,
    AboutComponent,
    FooterComponent,
    UserLoginComponent,
    UserRegButtonComponent,
    ForgotPassButtonComponent,
    LoaderComponent,
    ConfirmEmailComponent,
    ResetPasswordComponent,
    QuickSearchComponent,
    CompoundSearchComponent,
    SearchBoxComponent,
    StructureSearchComponent,
    SearchResultsTableComponent,
    TextSearchComponent,
    AssayIndicationComponent,
    KetcherComponent,
    StructureSearchOptionsComponent,
    DownloadGuideComponent,
    ForgotPasswordComponent,
    LoginFailComponent,
    UserRegistrationComponent,
    CompoundCardComponent,
    AssayProposalComponent,
    ContactUsComponent
  ],
  imports: [
    
    BrowserModule,
    MaterialModule,
    HttpModule,
    HttpClientModule,
    Struct2dModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    PipesModule,
    AppRoutingModule,
    RecaptchaModule.forRoot(),
    MatTableModule,
    UserPortalModule
  ],
  providers: [
    LoaderStateService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
    { provide: WDQService, useClass: WDQService },
    { provide: TanimotoScaleService, useClass: TanimotoScaleService },
    { provide: StructureService, useClass: StructureService },
    { provide: BackendSearchService, useClass: BackendSearchService },
    { provide: StructureSvgService, useClass: StructureSvgService },
    { provide: ColorPaletteService, useClass: ColorPaletteService },
    WDQService,
    LoginStateService,
    FavoritesService,
    CompoundListsService,
    DatePipe,
  ],
  entryComponents: [
    UserRegistrationComponent,
    LoginFailComponent,
    ForgotPasswordComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
